module.exports = __webpack_public_path__ + "img/DW365-020.be9fb35a.jpg";